import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface PasswordResetPageProps {
  onBack?: () => void;
}

const PasswordResetPage: React.FC<PasswordResetPageProps> = ({ onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate(`/login${location.search}`, { replace: true });
  }, [location.search, navigate]);

  return (
    <div className="auth-loading">
      <div className="loading-spinner-auth-page" />
      <p>Opening secure password reset...</p>
      <button type="button" className="auth-link" onClick={onBack}>Back</button>
    </div>
  );
};

export { PasswordResetPage };
